import { render, staticRenderFns } from "./AgentMerchantMachine.vue?vue&type=template&id=72c24030&scoped=true&"
import script from "./AgentMerchantMachine.vue?vue&type=script&lang=js&"
export * from "./AgentMerchantMachine.vue?vue&type=script&lang=js&"
import style0 from "./AgentMerchantMachine.vue?vue&type=style&index=0&id=72c24030&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c24030",
  null
  
)

export default component.exports